import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .constraints(constraint => constraint
    .endLocations(endLocation => endLocation.address.active.bestMatch.locationStatusId))
  .toString();
